/**
 * @generated SignedSource<<0e8f264a689fd284710c00c743402bfc>>
 * @relayHash c85fbefff721393de099841fc1e2682a
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c85fbefff721393de099841fc1e2682a

import { ConcreteRequest } from 'relay-runtime';
export type Ch_deletePrescriptionInput = {
  id: string;
};
export type useChDeletePrescriptionMutation$variables = {
  input: Ch_deletePrescriptionInput;
};
export type useChDeletePrescriptionMutation$data = {
  readonly ch_deletePrescription: {
    readonly ch_Prescription: {
      readonly id: string;
    } | null;
  };
};
export type useChDeletePrescriptionMutation = {
  response: useChDeletePrescriptionMutation$data;
  variables: useChDeletePrescriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChDeletePrescriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deletePrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_deletePrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_Prescription",
            "kind": "LinkedField",
            "name": "ch_Prescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChDeletePrescriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deletePrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_deletePrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_Prescription",
            "kind": "LinkedField",
            "name": "ch_Prescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "c85fbefff721393de099841fc1e2682a",
    "metadata": {},
    "name": "useChDeletePrescriptionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "f7d007ebfbecfabf7e7ca0e2194cb003";

export default node;
